import { QueryClient } from '@tanstack/react-query';

const envData: ImportMetaEnv = import.meta.env;

export default new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            staleTime: Number(envData.VITE_API_CACHE_TTL),
        },
    },
});
